import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import UsersTableInternalReplaceImage from "./UsersTableInternalReplaceImage";

export default function UserListInternalReplaceImage() {
  const location = useLocation();

  return (
    <div>
      <PageTitle activeMenu="Users List" motherMenu="User Management" />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <UsersTableInternalReplaceImage />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
